// Premium Apple-light design tokens - single source of truth
export const C = {
  bg: '#F3F6FA',
  surface: '#FFFFFF',
  surfaceAlt: '#F8FAFD',
  surfaceElevated: 'rgba(255,255,255,0.90)',
  border: 'rgba(22, 28, 36, 0.095)',
  borderStrong: 'rgba(22, 28, 36, 0.17)',
  hairline: 'rgba(22, 28, 36, 0.06)',
  text: '#111318',
  textSecondary: '#5A6372',
  textTertiary: '#9098A6',
  green: '#00C875',
  greenDark: '#007F4E',
  blue: '#007AFF',
  blueDark: '#004FC4',
  purple: '#6E5BFF',
  orange: '#FF9500',
  red: '#FF3B30',
  emerald: '#30D158',
  pink: '#FF2D55',
  sidebarBg: 'linear-gradient(180deg, rgba(255,255,255,0.92) 0%, rgba(248,251,255,0.82) 100%)',
  navHover: 'rgba(255,255,255,0.78)',
  navActive: 'linear-gradient(135deg, rgba(232,255,244,0.98) 0%, rgba(255,255,255,0.95) 66%, rgba(235,245,255,0.9) 100%)',
  shadowSoft: '0 1px 1px rgba(14,20,30,0.035), 0 12px 34px rgba(14,20,30,0.07)',
  shadowMedium: '0 1px 1px rgba(14,20,30,0.045), 0 20px 58px rgba(14,20,30,0.105)',
  shadowStrong: '0 14px 42px rgba(14,20,30,0.16), 0 42px 110px rgba(14,20,30,0.22)',
  greenShadow: '0 12px 30px rgba(0,200,117,0.24)',
  blueShadow: '0 12px 30px rgba(0,122,255,0.22)',
  cardInset: 'inset 0 1px 0 rgba(255,255,255,0.86), inset 0 -1px 0 rgba(22,28,36,0.035)',
  premiumSurface: 'linear-gradient(145deg, rgba(255,255,255,0.98) 0%, rgba(248,252,255,0.92) 48%, rgba(244,249,255,0.86) 100%)',
}
